import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useContext } from "react";
import { AuthContext } from "../context/AuthProvider";
import { Link } from "react-router-dom";
import { FiCopy } from "react-icons/fi";
import toast from "react-hot-toast";

const MyOrder = () => {
  const baseUrl = process.env.REACT_APP_API_URL;
  const { user } = useContext(AuthContext);

  const {
    data: ordersData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["my-orders"],
    queryFn: async () => {
      const res = await axios.get(`${baseUrl}order/my-orders/${user?._id}`);
      return res.data;
    },
  });

  if (isLoading) return <div className="text-center my-5">Loading...</div>;
  if (error)
    return <p className="text-danger text-center">Something went wrong.</p>;

  const orders = ordersData?.data || [];

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    toast.success("Order ID copied!");
  };

  return (
    <div className="container my-5">
      <h4 className="mb-4 text-primary">My Orders</h4>

      {orders.length === 0 ? (
        <p className="text-muted">No orders found.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-hover align-middle text-center">
            <thead className="table-primary">
              <tr>
                <th>Order ID</th>
                <th>User Name</th>
                <th>Total Amount</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order._id}>
                  <td className="text-nowrap">
                    <span className="badge bg-light text-dark">
                      {order.orderId}
                    </span>
                    <button
                      onClick={() => copyToClipboard(order.orderId)}
                      className="btn btn-sm text-primary ms-2"
                      title="Copy Order ID"
                    >
                      <FiCopy />
                    </button>
                  </td>
                  <td>{order.userName}</td>
                  <td>£{order.payableAmount}</td>
                  <td>
                    <span
                      className={`btn btn-sm  ${
                        order.status === "Pending"
                          ? "btn-warning"
                          : order.status === "Shipped"
                          ? "btn-primary"
                          : order.status === "Delivered"
                          ? "btn-success"
                          : order.status === "Canceled"
                          ? "btn-danger"
                          : "btn-secondary"
                      }`}
                      style={{ pointerEvents: "none" }}
                    >
                      {order.status || "Pending"}
                    </span>
                  </td>
                  <td>
                    <Link
                      to={`/order-details/${order._id}`}
                      className="btn btn-sm btn-outline-primary"
                    >
                      Details
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default MyOrder;
